import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addAdditionalSalay = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Additional Salary',
    body
  );
  return data;
});
export const updateAdditionalSalay = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Additional Salary/${id}`,
    body
  );
  return data;
});

export const getAdditionalSalay = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Additional Salary?fields=["name","docstatus","employee_name","salary_component","amount","type"]'
  );
  return data;
});
export const deleteAdditionalSalay = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Additional Salary/${record}`
  );
  return data;
});
export const getAdditionalSalayDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Additional Salary/${id}`
  );
  return data;
});
